import React from "react";

const contacts = [
  {
    title: "TikTok",
    phone: "+994 51 953 76 82",
    link: "https://wa.me/+994519537682",
    icon: "♪",
    color: "purple",
    description: "TikTok və sosial media üçün",
  },
  {
    title: "Pubg Mobile",
    phone: "+994 51 953 76 72",
    link: "https://wa.me/+994519537672",
    icon: "🎮",
    color: "cyan",
    description: "PUBG Mobile sifariş və dəstək",
  },
  {
    title: "FF Lounge",
    phone: "+994 70 563 43 33",
    link: "https://wa.me/+994705634333",
    icon: "☕",
    color: "gold",
    description: "FF Lounge və ümumi əlaqə",
  },
];

const Phone = () => {
  return (
    <main
      className="
        min-h-screen w-full overflow-x-hidden
        bg-[#f6f7fb] text-slate-900
        transition-colors duration-300
        dark:bg-[#05030a] dark:text-white
      "
    >
      {/* =========================================================
          HERO
      ========================================================= */}
      <section
        className="
          relative flex min-h-[205px] items-center justify-center
          overflow-hidden
          border-b border-slate-200
          bg-slate-100
          dark:border-white/[0.05]
          dark:bg-[#06040d]
          sm:min-h-[245px]
          md:min-h-[285px]
        "
      >
        {/* Background grid */}
        <div
          className="
            absolute inset-0 opacity-[0.35]
            dark:opacity-[0.18]
          "
          style={{
            backgroundImage: `
              linear-gradient(rgba(139,92,246,0.10) 1px, transparent 1px),
              linear-gradient(90deg, rgba(34,211,238,0.10) 1px, transparent 1px)
            `,
            backgroundSize: "32px 32px",
          }}
        />

        {/* Purple glow */}
        <div
          className="
            absolute left-[10%] top-[20%]
            h-32 w-32 rounded-full
            bg-purple-500/20 blur-[75px]
            dark:bg-purple-600/20
            sm:h-48 sm:w-48
          "
        />

        {/* Cyan glow */}
        <div
          className="
            absolute bottom-[0%] right-[8%]
            h-32 w-32 rounded-full
            bg-cyan-400/15 blur-[75px]
            dark:bg-cyan-500/15
            sm:h-48 sm:w-48
          "
        />

        {/* Gold center glow */}
        <div
          className="
            absolute left-1/2 top-1/2
            h-24 w-24
            -translate-x-1/2
            -translate-y-1/2
            rounded-full
            bg-[#d6b36a]/10
            blur-[65px]
            sm:h-40 sm:w-40
          "
        />

        {/* Decorative circles */}
        <div
          className="
            absolute left-1/2 top-1/2
            h-[190px] w-[190px]
            -translate-x-1/2
            -translate-y-1/2
            rounded-full
            border border-purple-500/10
            dark:border-purple-400/[0.08]
            sm:h-[260px] sm:w-[260px]
          "
        />

        <div
          className="
            absolute left-1/2 top-1/2
            h-[135px] w-[135px]
            -translate-x-1/2
            -translate-y-1/2
            rounded-full
            border border-cyan-400/10
            dark:border-cyan-400/[0.08]
            sm:h-[190px] sm:w-[190px]
          "
        />

        {/* Decorative lines */}
        <div className="absolute left-0 top-1/2 h-px w-[25%] bg-gradient-to-r from-transparent to-purple-500/20" />
        <div className="absolute right-0 top-1/2 h-px w-[25%] bg-gradient-to-l from-transparent to-cyan-500/20" />

        {/* Content */}
        <div className="relative z-10 px-4 text-center">
          {/* Badge */}
          <div
            className="
              mx-auto mb-3 inline-flex items-center gap-2
              rounded-full
              border border-[#d6b36a]/20
              bg-white/70
              px-3 py-1
              text-[9px] font-bold uppercase
              tracking-[0.28em]
              text-[#9b7836]
              shadow-sm
              backdrop-blur-md
              dark:border-[#d6b36a]/20
              dark:bg-[#0d0915]/80
              dark:text-[#d6b36a]
              sm:px-4 sm:py-1.5
              sm:text-[10px]
            "
          >
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.8)]" />
            FF QADİR
          </div>

          {/* Title */}
          <h1
            className="
              text-3xl font-black tracking-tight
              text-slate-900
              dark:text-white
              sm:text-4xl
              md:text-5xl
            "
          >
            Bizimlə{" "}
            <span
              className="
                bg-gradient-to-r
                from-purple-500
                via-fuchsia-500
                to-cyan-400
                bg-clip-text
                text-transparent
              "
            >
              Əlaqə
            </span>
          </h1>

          {/* Divider */}
          <div className="mx-auto mt-3 flex items-center justify-center gap-2">
            <div className="h-px w-8 bg-gradient-to-r from-transparent to-[#d6b36a]" />
            <div className="h-1.5 w-1.5 rotate-45 bg-[#d6b36a] shadow-[0_0_10px_rgba(214,179,106,0.6)]" />
            <div className="h-px w-8 bg-gradient-to-l from-transparent to-[#d6b36a]" />
          </div>

          <p
            className="
              mx-auto mt-3 max-w-md
              text-xs leading-5
              text-slate-500
              dark:text-white/45
              sm:text-sm
            "
          >
            Sualın, sifarişin və ya dəstəyə ehtiyacın varsa,
            bizimlə birbaşa WhatsApp üzərindən əlaqə saxla.
          </p>
        </div>

        {/* Bottom fade */}
        <div
          className="
            absolute bottom-0 left-0 right-0 h-16
            bg-gradient-to-t
            from-[#f6f7fb]
            to-transparent
            dark:from-[#05030a]
          "
        />
      </section>

      {/* =========================================================
          CONTACT CARDS
      ========================================================= */}
      <section
        className="
          relative mx-auto w-full max-w-5xl
          px-3 py-7
          sm:px-5 sm:py-10
          md:px-7 md:py-14
        "
      >
        {/* Ambient background */}
        <div
          className="
            pointer-events-none absolute left-[5%] top-[15%]
            h-40 w-40 rounded-full
            bg-purple-500/5 blur-[80px]
            dark:bg-purple-600/10
          "
        />

        <div
          className="
            pointer-events-none absolute bottom-[10%] right-[5%]
            h-40 w-40 rounded-full
            bg-cyan-500/5 blur-[80px]
            dark:bg-cyan-500/10
          "
        />

        {/* Small heading */}
        <div className="relative z-10 mb-5 text-center sm:mb-7">
          <p
            className="
              text-[9px] font-bold uppercase
              tracking-[0.3em]
              text-[#9b7836]
              dark:text-[#d6b36a]
              sm:text-[10px]
            "
          >
            Birbaşa əlaqə
          </p>

          <h2
            className="
              mt-1.5 text-xl font-black
              text-slate-900
              dark:text-white
              sm:text-2xl
            "
          >
            Sənə necə kömək edə bilərik?
          </h2>
        </div>

        {/* Cards */}
        <div
          className="
            relative z-10
            grid gap-3
            md:grid-cols-3
            md:gap-4
          "
        >
          {contacts.map((contact) => {
            const isPurple = contact.color === "purple";
            const isCyan = contact.color === "cyan";

            return (
              <a
                key={contact.title}
                href={contact.link}
                target="_blank"
                rel="noreferrer"
                className={`
                  group relative overflow-hidden
                  rounded-[18px]
                  border
                  p-4
                  transition-all duration-300
                  hover:-translate-y-1
                  sm:rounded-[22px]
                  sm:p-5

                  ${
                    isPurple
                      ? `
                        border-purple-500/15
                        bg-purple-50/70
                        hover:border-purple-500/35
                        hover:shadow-[0_18px_45px_rgba(139,92,246,0.14)]
                        dark:border-purple-500/[0.16]
                        dark:bg-[#0b0712]
                        dark:hover:border-purple-500/35
                        dark:hover:shadow-[0_18px_50px_rgba(139,92,246,0.12)]
                      `
                      : isCyan
                      ? `
                        border-cyan-500/15
                        bg-cyan-50/70
                        hover:border-cyan-500/35
                        hover:shadow-[0_18px_45px_rgba(34,211,238,0.14)]
                        dark:border-cyan-500/[0.16]
                        dark:bg-[#060b10]
                        dark:hover:border-cyan-500/35
                        dark:hover:shadow-[0_18px_50px_rgba(34,211,238,0.12)]
                      `
                      : `
                        border-[#d6b36a]/20
                        bg-[#fffaf0]
                        hover:border-[#d6b36a]/45
                        hover:shadow-[0_18px_45px_rgba(214,179,106,0.14)]
                        dark:border-[#d6b36a]/[0.18]
                        dark:bg-[#0d0a0b]
                        dark:hover:border-[#d6b36a]/40
                        dark:hover:shadow-[0_18px_50px_rgba(214,179,106,0.12)]
                      `
                  }
                `}
              >
                {/* Top shine */}
                <div
                  className={`
                    absolute left-0 right-0 top-0 h-px
                    opacity-50
                    ${
                      isPurple
                        ? "bg-gradient-to-r from-transparent via-purple-400 to-transparent"
                        : isCyan
                        ? "bg-gradient-to-r from-transparent via-cyan-400 to-transparent"
                        : "bg-gradient-to-r from-transparent via-[#d6b36a] to-transparent"
                    }
                  `}
                />

                {/* Background glow */}
                <div
                  className={`
                    absolute -right-10 -top-10
                    h-28 w-28 rounded-full
                    blur-3xl
                    transition-all duration-500
                    group-hover:scale-125
                    ${
                      isPurple
                        ? "bg-purple-500/10 group-hover:bg-purple-500/20 dark:bg-purple-500/10"
                        : isCyan
                        ? "bg-cyan-500/10 group-hover:bg-cyan-500/20 dark:bg-cyan-500/10"
                        : "bg-[#d6b36a]/10 group-hover:bg-[#d6b36a]/20 dark:bg-[#d6b36a]/10"
                    }
                  `}
                />

                <div className="relative z-10">
                  {/* Icon + status */}
                  <div className="flex items-center justify-between">
                    <div
                      className={`
                        flex h-11 w-11
                        items-center justify-center
                        rounded-[14px]
                        border
                        text-xl
                        transition-all duration-300
                        group-hover:scale-105
                        ${
                          isPurple
                            ? "border-purple-500/20 bg-purple-500/10 text-purple-500 dark:border-purple-500/20 dark:bg-purple-500/10 dark:text-purple-300"
                            : isCyan
                            ? "border-cyan-500/20 bg-cyan-500/10 text-cyan-500 dark:border-cyan-500/20 dark:bg-cyan-500/10 dark:text-cyan-300"
                            : "border-[#d6b36a]/25 bg-[#d6b36a]/10 text-[#a17d37] dark:border-[#d6b36a]/20 dark:bg-[#d6b36a]/10 dark:text-[#d6b36a]"
                        }
                      `}
                    >
                      {contact.icon}
                    </div>

                    <span
                      className="
                        inline-flex items-center gap-1
                        rounded-full
                        border border-emerald-500/20
                        bg-emerald-500/5
                        px-2 py-1
                        text-[8px] font-semibold
                        text-emerald-600
                        dark:border-emerald-400/15
                        dark:bg-emerald-400/5
                        dark:text-emerald-400
                      "
                    >
                      <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                      ONLINE
                    </span>
                  </div>

                  {/* Title */}
                  <h3
                    className="
                      mt-4 text-lg font-extrabold
                      text-slate-900
                      dark:text-white
                    "
                  >
                    {contact.title}
                  </h3>

                  {/* Description */}
                  <p
                    className="
                      mt-1 text-[11px] leading-4
                      text-slate-500
                      dark:text-white/40
                    "
                  >
                    {contact.description}
                  </p>

                  {/* Phone */}
                  <div
                    className="
                      mt-4 flex items-center
                      rounded-xl
                      border border-slate-200
                      bg-slate-50
                      px-3 py-2.5
                      dark:border-white/[0.05]
                      dark:bg-white/[0.025]
                    "
                  >
                    <span
                      className={`
                        text-[11px] font-bold
                        sm:text-xs
                        ${
                          isPurple
                            ? "text-purple-600 dark:text-purple-300"
                            : isCyan
                            ? "text-cyan-600 dark:text-cyan-300"
                            : "text-[#9b7836] dark:text-[#d6b36a]"
                        }
                      `}
                    >
                      {contact.phone}
                    </span>

                    <span
                      className="
                        ml-auto
                        text-base
                        text-slate-400
                        transition-transform duration-300
                        group-hover:translate-x-1
                        group-hover:text-slate-700
                        dark:text-white/30
                        dark:group-hover:text-white/70
                      "
                    >
                      →
                    </span>
                  </div>

                  {/* WhatsApp */}
                  <div
                    className="
                      mt-2 flex items-center
                      justify-center gap-1.5
                      text-[10px] font-semibold
                      text-slate-400
                      transition-colors
                      group-hover:text-emerald-500
                      dark:text-white/30
                      dark:group-hover:text-emerald-400
                    "
                  >
                    <span>WhatsApp ilə əlaqə saxla</span>
                    <span>↗</span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        {/* =====================================================
            BOTTOM INFO
        ===================================================== */}
        <div
          className="
            relative z-10 mx-auto mt-6
            max-w-2xl
            overflow-hidden
            rounded-[18px]
            border border-slate-200
            bg-white/70
            px-4 py-4
            text-center
            shadow-[0_15px_40px_rgba(15,23,42,0.05)]
            backdrop-blur-xl
            dark:border-white/[0.05]
            dark:bg-[#090611]
            dark:shadow-[0_20px_50px_rgba(0,0,0,0.4)]
            sm:mt-8
            sm:rounded-[22px]
            sm:px-6
            sm:py-5
          "
        >
          {/* Glow */}
          <div
            className="
              absolute left-1/2 top-0
              h-16 w-40
              -translate-x-1/2
              rounded-full
              bg-purple-500/5
              blur-3xl
              dark:bg-purple-500/10
            "
          />

          <div className="relative">
            <div
              className="
                mx-auto flex h-9 w-9
                items-center justify-center
                rounded-xl
                border border-[#d6b36a]/20
                bg-[#d6b36a]/10
                text-sm
              "
            >
              💬
            </div>

            <h3
              className="
                mt-2 text-sm font-bold
                text-slate-900
                dark:text-white
              "
            >
              Sürətli cavab, rahat əlaqə.
            </h3>

            <p
              className="
                mt-1 text-[10px] leading-4
                text-slate-500
                dark:text-white/35
              "
            >
              Uyğun bölməni seç və birbaşa WhatsApp söhbətinə keç.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Phone;